<template>
    <footer>
        <div class="footer-nav">
            <img src="@/assets/images/index/logo-footer.png" alt="" style="width: 13.1875rem;">
        </div>
        <!-- 网站导航 -->
        <div class="footer-nav">

            <div class="title">
                网站导航 • MENU
            </div>
            <!-- 分割线 -->
            <div class="line"></div>
            <!-- 内容 -->
            <div class="content">
                <div class="content-box" v-for="(item, index) in menuList" :key="index" @click="gotoNav(index)">{{
                    item.name }}</div>
            </div>
        </div>
        <!-- 联系方式 -->
        <div class="footer-nav">
            <div class="title">
                联系方式 • CONTACT
            </div>
            <!-- 分割线 -->
            <div class="line"></div>
            <!-- 内容 -->
            <div class="content">
                <div class="content-boxs" v-for="(item, index) in contactList" :key="index">{{ item.name + item.content
                }}
                </div>
            </div>
        </div>

        <!-- 版权信息 -->
        <div class="footer-left">
            <div><span>Copyright © 2015</span>
                <span>重庆溢希恩真节能电力设备有限公司</span>
                <span>版权所有</span>
            </div>
        </div>

    </footer>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter();
// 去往其他
const gotoNav = (index) => {
    router.push({
        path: menuList.value[index].path,
        query: {
            data: menuList.value[index].data
        }
    })
}
// 网站导航菜单
const menuList = ref([
    {
        name: '网站导航',
        path: '/'
    },
    {
        name: '产品中心',
        path: '/product-center/industry-AI'
    },
    {
        name: '解决方案',
        path: '/solution',
        data: '冲压'
    },
    {
        name: '成功案例',
        path: '/success-cases'
    },
    {
        name: '资讯动态',
        path: '/consulting-news'
    },
    {
        name: '关于我们',
        path: '/my/company-profile'
    },
    {}
])
// 联系方式
const contactList = ref([
    {
        name: '联系电话：',
        content: '023-62757988 / 13101235756'
    },
    {
        name: '公司地址：',
        content: '重庆市两江新区康美街道卉竹路2号互联网产业园二期6栋14层'
    },
])
</script>

<style lang="scss" scoped>
footer {
    cursor: pointer;
    width: 100%;
    height: 26.75rem;
    background: #131B1E;
    padding-left: 15.3125rem;
    padding-right: 15.3125rem;
    padding-top: 4.75rem;
    display: flex;
    color: #888;
    position: relative;
    // margin-top: 6.25rem;
}

.footer-nav {
    width: 30.5rem;
    // background-color: pink;
    margin-right: 7.25rem;

    .title {
        font-size: 1.375rem;
        text-align: left;
        color: #FFFFFF;
    }

    .line {
        width: 100%;
        height: .0625rem;
        background: #FFFFFF;
        opacity: 0.08;
        margin-top: 1.125rem;
    }

    .content {
        width: 100%;
        margin-top: 1.875rem;
        display: flex;
        flex-wrap: wrap;

        .content-box {
            width: 25%;
            text-align: left;
            margin-bottom: 1.625rem;
            font-size: .9375rem;
            transition: all 0.5s;

            &:hover {
                color: #FFF;
                transform: scale(1.1);
            }
        }

        .content-boxs {
            font-size: .9375rem;
            width: 100%;
            text-align: left;
            margin-bottom: 1.625rem;
            font-size: .9375rem;
            transition: all 0.5s;

            &:hover {
                color: #FFF;
                transform: scale(1.1);
            }
        }
    }


}

.footer-qrcode {
    position: absolute;
    right: 15.3125rem;

    img {
        width: 9.375rem;
        height: 9.375rem;
        transition: all 0.5s;

        &:hover {
            transform: scale(1.1);
        }
    }
}

.footer-left {
    position: absolute;
    left: 15.3125rem;
    bottom: 3.75rem;
    font-size: .9375rem;

    span {
        margin-right: 1.25rem;
    }
}

.footer-right {
    position: absolute;
    right: 15.3125rem;
    bottom: 3.75rem;
    font-size: .9375rem;

}
</style>